<p-table
  #dt
  [value]="value"
  [(selection)]="selectedItems"
  [rowHover]="true"
  dataKey="id"
  [paginator]="!!value!.length"
  [rows]="rows"
  [totalRecords]="totalRecords"
  (onLazyLoad)="handleLazyLoad($event)"
  [showCurrentPageReport]="true"
  [globalFilterFields]="globalFilterFields"
  currentPageReportTemplate="Pagina {currentPage} di {totalPages} con {totalRecords} risultati"
  (selectionChange)="selectionChange.emit($event)"
  [filterDelay]="100"
  [selectionMode]="enableSelection ? 'multiple' : null"
  [lazy]="true"
>

  <ng-template #caption>
    <div class="flex justify-between">
      <div class="flex align-middle justify-center">
        @if (customCaption) {
          <ng-container *ngTemplateOutlet="customCaption"></ng-container>
        }
        @if (enableFilterReset) {
          <p-button icon="pi pi-filter-slash" [rounded]="true" severity="info" [outlined]="true" (click)="clear(dt)"
                    pTooltip="Rimuovi Filtri"/>
        }
        @if(topbarTemplate){
          <ng-container *ngTemplateOutlet="topbarTemplate" class="me-4">
          </ng-container>
        }
      </div>

      <div class="flex">
        @if (enableSearch) {
          <input pInputText type="text" [(ngModel)]="searchValue"
                 (input)="dt.filterGlobal($any($event.target).value, 'contains')" placeholder="Cerca..."/>
        }
      </div>

    </div>
  </ng-template>

  @if (showHeader) {
    <ng-template #header>
      <tr>
        @if (enableSelection) {
          <th style="width: 4rem">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
        }

        @for (col of columns; track $index) {
          <th pSortableColumn="{{col.field}}">
            <div class="flex justify-between items-center text-sm">
              {{ col.header }}
              @if (col.sortable) {
                <p-sortIcon field="{{col.field}}"/>
              }
              @if (col.filterable) {
                <p-columnFilter type="text" field="{{col.field}}" display="menu" class="ml-auto" [showAddButton]="false" [showOperator]="false"/>
              }
            </div>
          </th>
        }

      </tr>
    </ng-template>
  }

  <ng-template #body let-row class="data-table-body">
    <tr class="p-selectable-row">
      @if (enableSelection) {
        <td>
          <p-tableCheckbox [value]="row"></p-tableCheckbox>
        </td>
      }

      @for (col of columns; track $index; ) {
        <td [ngClass]="col.buttons ? 'btn-col' : ''">
          @if (col.buttons) {
            <div class="flex gap-1 justify-end">
              @for (btn of col.buttons; track $index; ) {
                <p-button icon="pi {{btn.icon}}" [text]="true" [rounded]="true" size="small"
                          [pTooltip]="btn.tooltip" tooltipPosition="top" [severity]="btn.color"
                          [disabled]="btn.disabledAsFunction ? btn.disabledAsFunction!(row) : btn.disabled"
                          (click)="btn.click && btn.click(row)"/>
              }
            </div>
          }
          <ng-container [ngSwitch]="col.type">
            <img *ngSwitchCase="'image'" [src]="row[col.field!]" width="40" alt="image"/>
            <p-avatar *ngSwitchCase="'icon'"
                      [icon]="col.iconStyle.class"
                      styleClass="text-base font-medium flex"
                      size="normal"
                      shape="circle"
            />

            <ng-container *ngSwitchCase="'avatar'">
              @if (row[col.field!]) {
                <p-avatar
                  [image]="row[col.field!]"
                  size="large"
                  shape="circle">
                </p-avatar>
              } @else {
                <p-avatar
                  icon="pi pi-image"
                  size="large"
                  shape="circle">
                </p-avatar>
              }
            </ng-container>

            <div *ngSwitchCase="'template'">
              <ng-container
                *ngTemplateOutlet="col.customTemplate!; context: { $implicit: row }">
              </ng-container>
            </div>

            <div *ngSwitchCase="'tag'">
              <p-tag icon="pi pi-shield" severity="success" value="{{row[col.field!] | titlecase }}"/>
            </div>



            <div *ngSwitchCase="'date'">
              <ng-container>
                <div class="text-sm leading-5 text-muted-color">
                  {{ row[col.field!] | date:'dd-MM-yyyy HH:mm':'it' }}
                </div>
              </ng-container>
            </div>

            <div *ngSwitchCase="'dropdown'">
              <ng-container
                *ngTemplateOutlet="dropdown; context: { $implicit: row, column: col }">
              </ng-container>
            </div>


            <span *ngSwitchDefault class="text-right text-sm leading-5 text-muted-color">

              @if (col.transformer) {
                  {{col.transformer(row, row[col.field!])}}
              } @else {

                @if (row[col.field!] === 'media'){
                  <i class="fa-light fa-image-landscape"></i>
                }@else{

                {{ row[col.field!] && row[col.field!].length > 30
                ? (row[col.field!] | slice:0:30) + '…'
                : row[col.field!] }}}
              }

</span>
          </ng-container>
        </td>
      }
    </tr>
  </ng-template>



  <ng-template #emptymessage>
    <tr>
      <td [attr.colspan]="columns.length + 2">
        <div class="flex flex-col items-center justify-center py-16 gap-3 text-muted-color">
          <i class="fa-light fa-inbox text-4xl opacity-40"></i>
          <span class="text-sm">Nessun elemento trovato in questa sezione</span>
        </div>
      </td>
    </tr>
  </ng-template>


</p-table>

<ng-template #dropdown let-row let-column='column'>
  <p-floatlabel class="w-full md:w-56" variant="on">
    <p-select (onChange)="selectedOption($event, row, column)"
              [ngModel]="getNestedValue(row, column.field)"
              [disabled]="column.isDisabled && column.isDisabled(row)"
              inputId="on_label" [options]="column.dropdown.options"
              [optionLabel]="column.dropdown.optionLabel"
              [placeholder]="column.dropdown.placeholder"
              [optionValue]="column.dropdown.optionValue"
              styleClass="w-full"
              size="small"
              appendTo="body"/>
    <label for="on_label">{{ column.dropdown.label }}</label>
  </p-floatlabel>
</ng-template>
